export default {
  title: 'Din hjemmeside er klar',
  body_one: 'Reservationer er stadig slået fra for {{count}} restaurant:',
  body_other: 'Reservationer er stadig slået fra for {{count}} restauranter:',
  reasons: {
    license_required: 'Kræver en Partner-plan',
    notification_email_required:
      'Kræver en e-mailadresse til bookingnotifikationer. Tilføj den, når du aktiverer reservationer.',
    switched_off: 'Slået fra i reservationsindstillingerne',
    activation_failed: 'Kunne ikke slås til. Prøv igen i reservationsindstillingerne.',
  },
  buttons: {
    open_settings: 'Åbn reservationsindstillinger',
    continue: 'Fortsæt til hjemmesidebyggeren',
  },
};
